import axios from 'axios'
import moment from 'moment'
import { APP_EVENTS, JWT_TOKEN } from '../constants'
import { asyncGetCurrentAccountInformation } from '../services/account.services'
import { MyEventEmitter } from '../utils'
import setupAxiosInterceptors from '../setupAxiosInterceptors'

export const ENV = {
  BACKEND_PREFIX_URL: process.env.REACT_APP_BACKEND_PREFIX_URL
}

export const appEventEmitter = new MyEventEmitter()

export const initialization = async () => {
  setupAxiosInterceptors()
  axios.interceptors.request.use((config) => {
    const jwt = window.localStorage.getItem(JWT_TOKEN)
    config.headers = {
      ...config.headers,
      utcOffset: moment().utcOffset(),
      authorization: jwt && !config.headers?.notAddAuthorization ? `Bearer ${jwt}` : ''
    }
    return config
  })

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401) {
        window.localStorage.removeItem(JWT_TOKEN)
        // useNavigate() is invalid outside React components — hard redirect instead
        if (!window.location.pathname.startsWith('/login')) {
          window.location.assign('/login')
        }
        return Promise.reject(error)
      }
      return Promise.reject(error)
    }
  )

  try {
    return await Promise.all([asyncGetCurrentAccountInformation()])
  } catch (error: any) {
    // Stale JWT / unauthorized — continue to login UI instead of fatal ErrorPage
    if (error?.response?.status === 401) {
      return [undefined]
    }
    throw error
  }
}

export const processLoading = <T,>(promise: Promise<T>, tms?: number): Promise<T> => {
  return new Promise<T>((resolve, reject) => {
    const startTime = Date.now()
    appEventEmitter.emit(APP_EVENTS.app_loading, {
      display: true
    })
    promise
      .then((value) => {
        setTimeout(() => {
          appEventEmitter.emit(APP_EVENTS.app_loading, {
            display: false
          })
          resolve(value)
        }, startTime + (tms || 100) - Date.now())
      })
      .catch((error) => {
        setTimeout(() => {
          appEventEmitter.emit(APP_EVENTS.app_loading, {
            display: false
          })
          reject(error)
        }, startTime + (tms || 100) - Date.now())
      })
  })
}
